// extracted by mini-css-extract-plugin
export default {"app":"DataTopCard_app__cFsfx"};